import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { match } from "path-to-regexp";
import { routesConfig } from "../routesConfig";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, claims } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname;

  if (!isAuthenticated) {
    return <Navigate to="/unauthorized" replace state={{ from: location }} />;
  }

  // Find the matching route and its required roles
  let requiredRoles = [];
  for (const { path, roles } of Object.values(routesConfig)) {
    const matchPath = match(path, { decode: decodeURIComponent });
    if (matchPath(currentPath)) {
      requiredRoles = roles;
      break;
    }
  }

  // If no roles are required, allow access
  if (!requiredRoles.length) {
    return children;
  }

  // Check if user has at least one of the required roles
  const userRoles = claims?.roles || [];
  const hasAccess = requiredRoles.some((role) => userRoles.includes(role));

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
